<template>
  <Admin style="background: #f2f2f2">
    <v-main>
      <v-container fluid>
        <v-card class="rounded-xl tw-min-h-80">
          <div
            v-if="isLoading"
            class="tw-flex tw-items-center tw-justify-center tw-min-h-80"
          >
            <v-progress-circular
              color="primary"
              indeterminate
            ></v-progress-circular>
          </div>
          <v-card-text v-else>
            <div class="tw-flex tw-justify-between">
              <div
                class="tw-mx-5 tw-font-bold tw-text-xl tw-text-black tw-tracking-wide"
              >
                ตั้งค่า KBank
              </div>
              <v-btn
                color="primary"
                large
                outlined
                @click="isEditing = !isEditing"
                v-if="!isEditing"
              >
                <v-icon left>mdi-pencil</v-icon>
                แก้ไข
              </v-btn>
            </div>
            <div class="tw-mx-5">
              <v-form>
                <v-row>
                  <v-col cols="12">
                    <h3>Sandbox</h3>
                    <v-text-field
                      v-model="settingKBank.sandbox.consumerId"
                      class="tw-m-0 tw-pt-1"
                      dense
                      label="Consumer ID"
                      outlined
                      :readonly="!isEditing"
                    ></v-text-field>
                    <v-text-field
                      v-model="settingKBank.sandbox.consumerSecret"
                      class="tw-m-0 tw-pt-1"
                      dense
                      label="Consumer Secret"
                      outlined
                      :readonly="!isEditing"
                    ></v-text-field>
                    <v-text-field
                      v-model="settingKBank.sandbox.partnerId"
                      class="tw-m-0 tw-pt-1"
                      dense
                      label="Partner ID"
                      outlined
                      :readonly="!isEditing"
                    ></v-text-field>
                    <v-text-field
                      v-model="settingKBank.sandbox.partnerSecret"
                      class="tw-m-0 tw-pt-1"
                      dense
                      label="Partner Secret"
                      outlined
                      :readonly="!isEditing"
                    ></v-text-field>
                    <v-text-field
                      v-model="settingKBank.sandbox.merchantId"
                      class="tw-m-0 tw-pt-1"
                      dense
                      label="Merchant ID"
                      outlined
                      :readonly="!isEditing"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-divider></v-divider>
                <v-row>
                  <v-col cols="12">
                    <h3>UAT</h3>
                    <v-text-field
                      v-model="settingKBank.uat.consumerId"
                      class="tw-m-0 tw-pt-1"
                      dense
                      label="Consumer ID"
                      outlined
                      :readonly="!isEditing"
                    ></v-text-field>
                    <v-text-field
                      v-model="settingKBank.uat.consumerSecret"
                      class="tw-m-0 tw-pt-1"
                      dense
                      label="Consumer Secret"
                      outlined
                      :readonly="!isEditing"
                    ></v-text-field>
                    <v-text-field
                      v-model="settingKBank.uat.partnerId"
                      class="tw-m-0 tw-pt-1"
                      dense
                      label="Partner ID"
                      outlined
                      :readonly="!isEditing"
                    ></v-text-field>
                    <v-text-field
                      v-model="settingKBank.uat.partnerSecret"
                      class="tw-m-0 tw-pt-1"
                      dense
                      label="Partner Secret"
                      outlined
                      :readonly="!isEditing"
                    ></v-text-field>
                    <v-text-field
                      v-model="settingKBank.uat.merchantId"
                      class="tw-m-0 tw-pt-1"
                      dense
                      label="Merchant ID"
                      outlined
                      :readonly="!isEditing"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-divider></v-divider>
                <v-row>
                  <v-col cols="12">
                    <h3>Production</h3>
                    <v-text-field
                      v-model="settingKBank.production.consumerId"
                      class="tw-m-0 tw-pt-1"
                      dense
                      label="Consumer ID"
                      outlined
                      :readonly="!isEditing"
                    ></v-text-field>
                    <v-text-field
                      v-model="settingKBank.production.consumerSecret"
                      class="tw-m-0 tw-pt-1"
                      dense
                      label="Consumer Secret"
                      outlined
                      :readonly="!isEditing"
                    ></v-text-field>
                    <v-text-field
                      v-model="settingKBank.production.partnerId"
                      class="tw-m-0 tw-pt-1"
                      dense
                      label="Partner ID"
                      outlined
                      :readonly="!isEditing"
                    ></v-text-field>
                    <v-text-field
                      v-model="settingKBank.production.partnerSecret"
                      class="tw-m-0 tw-pt-1"
                      dense
                      label="Partner Secret"
                      outlined
                      :readonly="!isEditing"
                    ></v-text-field>
                    <v-text-field
                      v-model="settingKBank.production.merchantId"
                      class="tw-m-0 tw-pt-1"
                      dense
                      label="Merchant ID"
                      outlined
                      :readonly="!isEditing"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <div class="tw-flex tw-justify-end">
                  <v-btn
                    color="primary"
                    large
                    outlined
                    @click="isEditing = !isEditing"
                    v-if="isEditing"
                  >
                    <v-icon left>mdi-close</v-icon>
                    ยกเลิก
                  </v-btn>
                  <v-btn
                    :loading="isSaving"
                    color="primary"
                    large
                    @click="save"
                    v-if="isEditing"
                  >
                    <v-icon left>mdi-content-save</v-icon>
                    บันทึก
                  </v-btn>
                </div>
              </v-form>
            </div>
          </v-card-text>
        </v-card>
      </v-container>
    </v-main>
  </Admin>
</template>

<script>
import Admin from "../../components/admin/admin-main-template";
import fc from "@/firebaseConfig";

export default {
  name: "SettingKBank",
  components: {
    Admin,
  },
  data: () => ({
    isLoading: false,
    isSaving: false,
    isEditing: false,
    settingKBank: {
      sandbox: {
        consumerId: "",
        consumerSecret: "",
        partnerId: "",
        partnerSecret: "",
        merchantId: "",
      },
      uat: {
        consumerId: "",
        consumerSecret: "",
        partnerId: "",
        partnerSecret: "",
        merchantId: "",
      },
      production: {
        consumerId: "",
        consumerSecret: "",
        partnerId: "",
        partnerSecret: "",
        merchantId: "",
      },
    },
  }),
  methods: {
    async save() {
      try {
        this.isSaving = true;
        const data = this.settingKBank;
        const companyId = this.$router.currentRoute.params.companyId;
        const settingPath = `/Companies/${companyId}/SettingKBank/qrPayment`;
        const companyPath = `/Companies/${companyId}`;

        console.log("Setting path:", settingPath);
        console.log("Company path:", companyPath);

        // Execute both Firestore updates concurrently
        await Promise.all([
          fc.db.doc(settingPath).set(data, { merge: true }),
          fc.db.doc(companyPath).set({ isKBankEnable: true }, { merge: true }),
        ]);

        console.log("Saved KBank configuration and updated company:", data);
      } finally {
        this.isSaving = false;
        this.isEditing = false;
      }
    },
    listenToKBankSetting() {
      const companyId = this.$router.currentRoute.params.companyId;
      const settingPath = `/Companies/${companyId}/SettingKBank/qrPayment`;
      const settingDoc = fc.db.doc(settingPath);

      this.isLoading = true;
      settingDoc.onSnapshot(
        (snapshot) => {
          const data = snapshot.data();
          if (snapshot.exists && data) {
            this.settingKBank = {
              sandbox: {
                consumerId: data.sandbox?.consumerId || "",
                consumerSecret: data.sandbox?.consumerSecret || "",
                partnerId: data.sandbox?.partnerId || "",
                partnerSecret: data.sandbox?.partnerSecret || "",
                merchantId: data.sandbox?.merchantId || "",
              },
              uat: {
                consumerId: data.uat?.consumerId || "",
                consumerSecret: data.uat?.consumerSecret || "",
                partnerId: data.uat?.partnerId || "",
                partnerSecret: data.uat?.partnerSecret || "",
                merchantId: data.uat?.merchantId || "",
              },
              production: {
                consumerId: data.production?.consumerId || "",
                consumerSecret: data.production?.consumerSecret || "",
                partnerId: data.production?.partnerId || "",
                partnerSecret: data.production?.partnerSecret || "",
                merchantId: data.production?.merchantId || "",
              },
            };
          } else {
            this.settingKBank = {
              sandbox: {
                consumerId: "",
                consumerSecret: "",
                partnerId: "",
                partnerSecret: "",
                merchantId: "",
              },
              uat: {
                consumerId: "",
                consumerSecret: "",
                partnerId: "",
                partnerSecret: "",
                merchantId: "",
              },
              production: {
                consumerId: "",
                consumerSecret: "",
                partnerId: "",
                partnerSecret: "",
                merchantId: "",
              },
            };
          }
          this.isLoading = false;
        },
        (error) => {
          console.error(`${companyId}/SettingKBank/qrPayment`, error);
          this.isLoading = false;
        }
      );
    },
  },
  async mounted() {
    this.listenToKBankSetting();
  },
};
</script>

<style lang="scss">
.row-wrapper {
  padding-left: 20px;
}
</style>
